// extracted by mini-css-extract-plugin
module.exports = {"trashIcon":"citation-delete-icon_trashIcon__O2blq"};